import { parse, stringify } from 'uuid';
export var EdgeType;
(function (EdgeType) {
    EdgeType["ANNOTATION"] = "ANNOTATION";
    EdgeType["ATTRIBUTE"] = "ATTRIBUTE";
    EdgeType["CUSTOM"] = "CUSTOM";
})(EdgeType || (EdgeType = {}));
export class Edge {
    constructor(id, from, to, type, typeName) {
        // TODO is this a valid Edge?
        // if (typeName && type !== EdgeType.CUSTOM) throw
        this.id = stringify(parse(id));
        this.from = stringify(parse(from));
        this.to = stringify(parse(to));
        this.type = type;
        this.typeName = typeName;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL0VkZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFFdkMsTUFBTSxDQUFOLElBQVksUUFJWDtBQUpELFdBQVksUUFBUTtJQUNsQixxQ0FBeUIsQ0FBQTtJQUN6QixtQ0FBdUIsQ0FBQTtJQUN2Qiw2QkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSlcsUUFBUSxLQUFSLFFBQVEsUUFJbkI7QUFFRCxNQUFNLE9BQU8sSUFBSTtJQU9mLFlBQ0UsRUFBVSxFQUNWLElBQVksRUFDWixFQUFVLEVBQ1YsSUFBYyxFQUNkLFFBQWlCO1FBRWpCLDZCQUE2QjtRQUM3QixrREFBa0Q7UUFFbEQsSUFBSSxDQUFDLEVBQUUsR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDOUIsSUFBSSxDQUFDLElBQUksR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7UUFDbEMsSUFBSSxDQUFDLEVBQUUsR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDOUIsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUE7UUFDaEIsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUE7SUFDMUIsQ0FBQztDQUNGIn0=